/**
 * â”Œâ”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”
 * â”‚ This file has been generated by designTokens.ts                       â”‚
 * â”‚                                                                        â”‚
 * â”‚ Source of truth: figma-design-tokens-core.json                         â”‚
 * â”‚                  figma-design-tokens-components.json                   â”‚
 * â”‚ Extra reference normalization lives in the generator script.           â”‚
 * â”‚ Please do not edit this file manually.                                 â”‚
 * â”‚ Run: yarn tokens                                                       â”‚
 * â””â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”˜
 */
import { theme } from "./theme.generated";

import type { StandardSpacingNames } from "./theme.generated";
import type { MarginAway } from "./theme.types";

export const flattenedCssVariables = {
    "color-ui-1": theme.color.ui[1],
    "color-ui-2": theme.color.ui[2],
    "color-ui-3": theme.color.ui[3],
    "color-ui-4": theme.color.ui[4],
    "color-ui-5": theme.color.ui[5],
    "color-ui-6": theme.color.ui[6],
    "color-ui-7": theme.color.ui[7],
    "color-ui-8": theme.color.ui[8],
    "color-primary-200": theme.color.primary[200],
    "color-primary-300": theme.color.primary[300],
    "color-primary-500": theme.color.primary[500],
    "color-primary-700": theme.color.primary[700],
    "color-shine-300": theme.color.shine[300],
    "color-shine-500": theme.color.shine[500],
    "color-shine-600": theme.color.shine[600],
    "color-shine-700": theme.color.shine[700],
    "color-sunset-300": theme.color.sunset[300],
    "color-sunset-500": theme.color.sunset[500],
    "color-sunset-600": theme.color.sunset[600],
    "color-sunset-700": theme.color.sunset[700],
    "color-harvest-300": theme.color.harvest[300],
    "color-harvest-500": theme.color.harvest[500],
    "color-harvest-600": theme.color.harvest[600],
    "color-harvest-700": theme.color.harvest[700],
    "color-cozy-200": theme.color.cozy[200],
    "color-cozy-300": theme.color.cozy[300],
    "color-cozy-500": theme.color.cozy[500],
    "color-cozy-700": theme.color.cozy[700],
    "color-warm-100": theme.color.warm[100],
    "color-warm-200": theme.color.warm[200],
    "color-warm-300": theme.color.warm[300],
    "color-warm-500": theme.color.warm[500],
    "color-action-focus": theme.color.action.focus,
    "color-reserved-inherit": theme.color.reserved.inherit,
    "color-reserved-transparent": theme.color.reserved.transparent,
    "color-base": theme.color.base,
    "color-destructive-100": theme.color.destructive[100],
    "color-destructive-200": theme.color.destructive[200],
    "color-destructive-300": theme.color.destructive[300],
    "color-destructive-500": theme.color.destructive[500],
    "color-destructive-600": theme.color.destructive[600],
    "color-destructive-700": theme.color.destructive[700],
    "color-lilac-200": theme.color.lilac[200],
    "color-lilac-300": theme.color.lilac[300],
    "color-lilac-500": theme.color.lilac[500],
    "color-lilac-700": theme.color.lilac[700],
    "color-success-100": theme.color.success[100],
    "color-success-200": theme.color.success[200],
    "color-success-300": theme.color.success[300],
    "color-success-500": theme.color.success[500],
    "color-success-600": theme.color.success[600],
    "color-success-700": theme.color.success[700],
    "color-warning-100": theme.color.warning[100],
    "color-warning-200": theme.color.warning[200],
    "color-warning-300": theme.color.warning[300],
    "color-warning-500": theme.color.warning[500],
    "color-warning-600": theme.color.warning[600],
    "color-warning-700": theme.color.warning[700],
    "color-burgundy-100": theme.color.burgundy[100],
    "color-burgundy-200": theme.color.burgundy[200],
    "color-burgundy-300": theme.color.burgundy[300],
    "color-burgundy-500": theme.color.burgundy[500],
    "color-burgundy-700": theme.color.burgundy[700],
    "palette-ui-1": "#1c1a18",
    "palette-ui-2": "#46403c",
    "palette-ui-3": "#5d5854",
    "palette-ui-4": "#b2afac",
    "palette-ui-5": "#ccc9c6",
    "palette-ui-6": "#e4e3e1",
    "palette-ui-7": "#f5f4f3",
    "palette-ui-8": "#ffffff",
    "palette-primary-200": "#cfe1ff",
    "palette-primary-300": "#87adf5",
    "palette-primary-500": "#1259ef",
    "palette-primary-700": "#28169b",
    "palette-shine-300": "#ffe6b1",
    "palette-shine-500": "#ffcd62",
    "palette-shine-600": "#b98108",
    "palette-shine-700": "#ffaa00",
    "palette-sunset-300": "#ffc9c9",
    "palette-sunset-500": "#ff5a5a",
    "palette-sunset-600": "#e71f1f",
    "palette-sunset-700": "#9e1515",
    "palette-harvest-300": "#c6ffc9",
    "palette-harvest-500": "#8eff94",
    "palette-harvest-600": "#437d46",
    "palette-harvest-700": "#2a4b2c",
    "palette-cozy-200": "#ebe5ff",
    "palette-cozy-300": "#cdc4ff",
    "palette-cozy-500": "#7154e6",
    "palette-cozy-700": "#2c145b",
    "palette-warm-100": "#fbf9f7",
    "palette-warm-200": "#f5f0ea",
    "palette-warm-300": "#e9e2d9",
    "palette-warm-500": "#66615b",
    "palette-action-focus": "#80C5FF",
    "palette-reserved-inherit": "inherit",
    "palette-reserved-transparent": "rgba(0,0,0,0)",
    "palette-base": "#fff",
    "color-text-ui-primary": theme.semantic["color-text"].ui.primary,
    "color-text-ui-secondary": theme.semantic["color-text"].ui.secondary,
    "color-text-ui-subtle": theme.semantic["color-text"].ui.subtle,
    "color-text-ui-link": theme.semantic["color-text"].ui.link,
    "color-text-ui-on-dark-bg": theme.semantic["color-text"].ui["on-dark-bg"],
    "color-text-ui-muted": theme.semantic["color-text"].ui.muted,
    "color-text-feedback-error": theme.semantic["color-text"].feedback.error,
    "color-text-feedback-info": theme.semantic["color-text"].feedback.info,
    "color-text-feedback-warning": theme.semantic["color-text"].feedback.warning,
    "color-text-feedback-success": theme.semantic["color-text"].feedback.success,
    "color-text-feedback-promotional": theme.semantic["color-text"].feedback.promotional,
    "color-ui-surface-default": theme.semantic["color-ui"]["surface-default"],
    "color-ui-page": theme.semantic["color-ui"].page,
    "color-ui-dark-subtle": theme.semantic["color-ui"]["dark-subtle"],
    "color-ui-dark": theme.semantic["color-ui"].dark,
    "color-ui-light-subtle": theme.semantic["color-ui"]["light-subtle"],
    "color-ui-primary-highlight": theme.semantic["color-ui"].primary.highlight,
    "color-ui-primary-contrast": theme.semantic["color-ui"].primary.contrast,
    "color-ui-primary-medium": theme.semantic["color-ui"].primary.medium,
    "color-ui-primary-subtle": theme.semantic["color-ui"].primary.subtle,
    "color-ui-shine-highlight": theme.semantic["color-ui"].shine.highlight,
    "color-ui-shine-contrast": theme.semantic["color-ui"].shine.contrast,
    "color-ui-shine-subtle": theme.semantic["color-ui"].shine.subtle,
    "color-ui-harvest-highlight": theme.semantic["color-ui"].harvest.highlight,
    "color-ui-harvest-contrast": theme.semantic["color-ui"].harvest.contrast,
    "color-ui-harvest-subtle": theme.semantic["color-ui"].harvest.subtle,
    "color-ui-sunset-highlight": theme.semantic["color-ui"].sunset.highlight,
    "color-ui-sunset-contrast": theme.semantic["color-ui"].sunset.contrast,
    "color-ui-sunset-subtle": theme.semantic["color-ui"].sunset.subtle,
    "color-ui-cozy-dark": theme.semantic["color-ui"].cozy.dark,
    "color-ui-cozy-contrast": theme.semantic["color-ui"].cozy.contrast,
    "color-ui-cozy-subtle": theme.semantic["color-ui"].cozy.subtle,
    "color-ui-cozy-highlight": theme.semantic["color-ui"].cozy.highlight,
    "color-ui-light": theme.semantic["color-ui"].light,
    "color-ui-warm-highlight": theme.semantic["color-ui"].warm.highlight,
    "color-ui-warm-contrast": theme.semantic["color-ui"].warm.contrast,
    "color-ui-warm-subtle": theme.semantic["color-ui"].warm.subtle,
    "color-ui-medium": theme.semantic["color-ui"].medium,
    "color-ui-medium-subtle": theme.semantic["color-ui"]["medium-subtle"],
    "color-border-surface-module": theme.semantic["color-border"]["surface-module"],
    "color-border-surface-default": theme.semantic["color-border"]["surface-default"],
    "color-border-surface-light": theme.semantic["color-border"]["surface-light"],
    "color-feedback-bg-caution": theme.semantic["color-feedback"].bg.caution,
    "color-feedback-bg-danger": theme.semantic["color-feedback"].bg.danger,
    "color-feedback-bg-information": theme.semantic["color-feedback"].bg.information,
    "color-feedback-bg-positive": theme.semantic["color-feedback"].bg.positive,
    "color-feedback-bg-promotion": theme.semantic["color-feedback"].bg.promotion,
    "color-icon-ui-primary": theme.semantic["color-icon"].ui.primary,
    "color-icon-ui-secondary": theme.semantic["color-icon"].ui.secondary,
    "color-icon-ui-subtle": theme.semantic["color-icon"].ui.subtle,
    "color-icon-ui-link": theme.semantic["color-icon"].ui.link,
    "color-icon-ui-on-dark-bg": theme.semantic["color-icon"].ui["on-dark-bg"],
    "color-icon-ui-muted": theme.semantic["color-icon"].ui.muted,
    "color-icon-feedback-error": theme.semantic["color-icon"].feedback.error,
    "color-icon-feedback-info": theme.semantic["color-icon"].feedback.info,
    "color-icon-feedback-warning": theme.semantic["color-icon"].feedback.warning,
    "color-icon-feedback-success": theme.semantic["color-icon"].feedback.success,
    "breakpoint-mobile": "480px",
    "breakpoint-mobile-max": "767px",
    "breakpoint-tablet-portrait": "768px",
    "breakpoint-tablet-portrait-max": "1023px",
    "breakpoint-tablet-landscape": "1024px",
    "breakpoint-tablet-landscape-max": "1279px",
    "breakpoint-desktop": "1280px",
    "breakpoint-desktop-max": "1599px",
    "breakpoint-desktop-large": "1600px",
    "typography-weight-bold": 700,
    "typography-weight-medium": 500,
    "typography-weight-regular": 400,
    "typography-weight-semibold": 600,
    "spacing-0": "0px",
    "spacing-4": "4px",
    "spacing-6": "6px",
    "spacing-8": "8px",
    "spacing-12": "12px",
    "spacing-16": "16px",
    "spacing-24": "24px",
    "spacing-32": "32px",
    "spacing-40": "40px",
    "spacing-48": "48px",
    "modal-padding-top": "50px",
    "modal-padding-bottom": "90px",
    "modal-content-padding": "16px",
    "modal-content-max-height": "calc(100vh - #{$modal-padding-top} - #{$modal-padding-bottom} - 57px - 69px)",
} as const;

export const themeColors = {
    "color-ui-1": theme.color.ui[1],
    "color-ui-2": theme.color.ui[2],
    "color-ui-3": theme.color.ui[3],
    "color-ui-4": theme.color.ui[4],
    "color-ui-5": theme.color.ui[5],
    "color-ui-6": theme.color.ui[6],
    "color-ui-7": theme.color.ui[7],
    "color-ui-8": theme.color.ui[8],
    "color-primary-200": theme.color.primary[200],
    "color-primary-300": theme.color.primary[300],
    "color-primary-500": theme.color.primary[500],
    "color-primary-700": theme.color.primary[700],
    "color-shine-300": theme.color.shine[300],
    "color-shine-500": theme.color.shine[500],
    "color-shine-600": theme.color.shine[600],
    "color-shine-700": theme.color.shine[700],
    "color-sunset-300": theme.color.sunset[300],
    "color-sunset-500": theme.color.sunset[500],
    "color-sunset-600": theme.color.sunset[600],
    "color-sunset-700": theme.color.sunset[700],
    "color-harvest-300": theme.color.harvest[300],
    "color-harvest-500": theme.color.harvest[500],
    "color-harvest-600": theme.color.harvest[600],
    "color-harvest-700": theme.color.harvest[700],
    "color-cozy-200": theme.color.cozy[200],
    "color-cozy-300": theme.color.cozy[300],
    "color-cozy-500": theme.color.cozy[500],
    "color-cozy-700": theme.color.cozy[700],
    "color-warm-100": theme.color.warm[100],
    "color-warm-200": theme.color.warm[200],
    "color-warm-300": theme.color.warm[300],
    "color-warm-500": theme.color.warm[500],
    "color-action-focus": theme.color.action.focus,
    "color-reserved-inherit": theme.color.reserved.inherit,
    "color-reserved-transparent": theme.color.reserved.transparent,
    "color-base": theme.color.base,
    "color-destructive-100": theme.color.destructive[100],
    "color-destructive-200": theme.color.destructive[200],
    "color-destructive-300": theme.color.destructive[300],
    "color-destructive-500": theme.color.destructive[500],
    "color-destructive-600": theme.color.destructive[600],
    "color-destructive-700": theme.color.destructive[700],
    "color-lilac-200": theme.color.lilac[200],
    "color-lilac-300": theme.color.lilac[300],
    "color-lilac-500": theme.color.lilac[500],
    "color-lilac-700": theme.color.lilac[700],
    "color-success-100": theme.color.success[100],
    "color-success-200": theme.color.success[200],
    "color-success-300": theme.color.success[300],
    "color-success-500": theme.color.success[500],
    "color-success-600": theme.color.success[600],
    "color-success-700": theme.color.success[700],
    "color-warning-100": theme.color.warning[100],
    "color-warning-200": theme.color.warning[200],
    "color-warning-300": theme.color.warning[300],
    "color-warning-500": theme.color.warning[500],
    "color-warning-600": theme.color.warning[600],
    "color-warning-700": theme.color.warning[700],
    "color-burgundy-100": theme.color.burgundy[100],
    "color-burgundy-200": theme.color.burgundy[200],
    "color-burgundy-300": theme.color.burgundy[300],
    "color-burgundy-500": theme.color.burgundy[500],
    "color-burgundy-700": theme.color.burgundy[700],
    "color-text-ui-primary": theme.semantic["color-text"].ui.primary,
    "color-text-ui-secondary": theme.semantic["color-text"].ui.secondary,
    "color-text-ui-subtle": theme.semantic["color-text"].ui.subtle,
    "color-text-ui-link": theme.semantic["color-text"].ui.link,
    "color-text-ui-on-dark-bg": theme.semantic["color-text"].ui["on-dark-bg"],
    "color-text-ui-muted": theme.semantic["color-text"].ui.muted,
    "color-text-feedback-error": theme.semantic["color-text"].feedback.error,
    "color-text-feedback-info": theme.semantic["color-text"].feedback.info,
    "color-text-feedback-warning": theme.semantic["color-text"].feedback.warning,
    "color-text-feedback-success": theme.semantic["color-text"].feedback.success,
    "color-text-feedback-promotional": theme.semantic["color-text"].feedback.promotional,
    "color-ui-surface-default": theme.semantic["color-ui"]["surface-default"],
    "color-ui-page": theme.semantic["color-ui"].page,
    "color-ui-dark-subtle": theme.semantic["color-ui"]["dark-subtle"],
    "color-ui-dark": theme.semantic["color-ui"].dark,
    "color-ui-light-subtle": theme.semantic["color-ui"]["light-subtle"],
    "color-ui-primary-highlight": theme.semantic["color-ui"].primary.highlight,
    "color-ui-primary-contrast": theme.semantic["color-ui"].primary.contrast,
    "color-ui-primary-medium": theme.semantic["color-ui"].primary.medium,
    "color-ui-primary-subtle": theme.semantic["color-ui"].primary.subtle,
    "color-ui-shine-highlight": theme.semantic["color-ui"].shine.highlight,
    "color-ui-shine-contrast": theme.semantic["color-ui"].shine.contrast,
    "color-ui-shine-subtle": theme.semantic["color-ui"].shine.subtle,
    "color-ui-harvest-highlight": theme.semantic["color-ui"].harvest.highlight,
    "color-ui-harvest-contrast": theme.semantic["color-ui"].harvest.contrast,
    "color-ui-harvest-subtle": theme.semantic["color-ui"].harvest.subtle,
    "color-ui-sunset-highlight": theme.semantic["color-ui"].sunset.highlight,
    "color-ui-sunset-contrast": theme.semantic["color-ui"].sunset.contrast,
    "color-ui-sunset-subtle": theme.semantic["color-ui"].sunset.subtle,
    "color-ui-cozy-dark": theme.semantic["color-ui"].cozy.dark,
    "color-ui-cozy-contrast": theme.semantic["color-ui"].cozy.contrast,
    "color-ui-cozy-subtle": theme.semantic["color-ui"].cozy.subtle,
    "color-ui-cozy-highlight": theme.semantic["color-ui"].cozy.highlight,
    "color-ui-light": theme.semantic["color-ui"].light,
    "color-ui-warm-highlight": theme.semantic["color-ui"].warm.highlight,
    "color-ui-warm-contrast": theme.semantic["color-ui"].warm.contrast,
    "color-ui-warm-subtle": theme.semantic["color-ui"].warm.subtle,
    "color-ui-medium": theme.semantic["color-ui"].medium,
    "color-ui-medium-subtle": theme.semantic["color-ui"]["medium-subtle"],
    "color-border-surface-module": theme.semantic["color-border"]["surface-module"],
    "color-border-surface-default": theme.semantic["color-border"]["surface-default"],
    "color-border-surface-light": theme.semantic["color-border"]["surface-light"],
    "color-feedback-bg-caution": theme.semantic["color-feedback"].bg.caution,
    "color-feedback-bg-danger": theme.semantic["color-feedback"].bg.danger,
    "color-feedback-bg-information": theme.semantic["color-feedback"].bg.information,
    "color-feedback-bg-positive": theme.semantic["color-feedback"].bg.positive,
    "color-feedback-bg-promotion": theme.semantic["color-feedback"].bg.promotion,
    "color-icon-ui-primary": theme.semantic["color-icon"].ui.primary,
    "color-icon-ui-secondary": theme.semantic["color-icon"].ui.secondary,
    "color-icon-ui-subtle": theme.semantic["color-icon"].ui.subtle,
    "color-icon-ui-link": theme.semantic["color-icon"].ui.link,
    "color-icon-ui-on-dark-bg": theme.semantic["color-icon"].ui["on-dark-bg"],
    "color-icon-ui-muted": theme.semantic["color-icon"].ui.muted,
    "color-icon-feedback-error": theme.semantic["color-icon"].feedback.error,
    "color-icon-feedback-info": theme.semantic["color-icon"].feedback.info,
    "color-icon-feedback-warning": theme.semantic["color-icon"].feedback.warning,
    "color-icon-feedback-success": theme.semantic["color-icon"].feedback.success,
} as const;

export const themeSpacings: StandardSpacingNames[] = ["0","4","6","8","12","16","24","32","40","48"];
export const marginAway: MarginAway[] = ["0","4","6","8","12","16","24","32","40","48","24t16m"];